function Darkmode() {
	if (localStorage.getItem('loadingse-darkmode') == 'true') {
		return true;
	}

	return false;
}

export default Darkmode;
